import { Content } from '@amzn/awscat-pattern-library-service-model';

import { descriptionInputMaxLength, descriptionInputMinLength } from '../api/UtilsApi';
import { deepCloneContent } from '../model/CloneContent';

/**
 * Validates a description string. Returns an error message when the length
 * is out of bounds, otherwise `undefined`.
 */
export function validateDescription(text: string): string | undefined {
  if (text.length < descriptionInputMinLength || text.length > descriptionInputMaxLength) {
    return `Description must be between ${descriptionInputMinLength} and ${descriptionInputMaxLength} characters.`;
  }
  return undefined;
}

/**
 * Returns a clone of `content` with `description` set to `text`. Does NOT
 * mutate the input.
 */
export function setContentDescription(content: Content, text: string): Content {
  const updated = deepCloneContent(content);
  updated.contentMetadata.description = text;
  return updated;
}
